/**
 * Stała przechowująca klucze do danych w localStorage
 *
 * @constant
 */
export const LocalStorageKeyConstants = {
  //TODO sukcesywnie przenosić inne zahardkodowane klucze
  REDIRECT_PATH: "redirectPath",
};
